import React from 'react';
import { Link } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { calculateLevel, getLevelTitle } from '../utils/xpSystem';
import './Home.css';

const Home = () => {
  const { totalXP, theme, toggleTheme } = useGame();
  const level = calculateLevel(totalXP);
  const title = getLevelTitle(level);

  const popularTopics = [
    { id: 'bash', name: 'Bash', icon: '🐧', lessons: 30, color: '#4CAF50' },
    { id: 'linux', name: 'Linux', icon: '💻', lessons: 30, color: '#F44336' },
    { id: 'docker', name: 'Docker', icon: '🐳', lessons: 30, color: '#2496ED' },
    { id: 'git', name: 'Git', icon: '📝', lessons: 30, color: '#FF9800' },
  ];

  return (
    <div className="home">
      {/* Theme Toggle */}
      <button
        className="home-theme-toggle"
        onClick={toggleTheme}
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      >
        {theme === 'light' ? '🌙' : '☀️'}
      </button>

      {/* Hero Section */}
      <section className="hero">
        <h1>Command Learn</h1>
        <p className="subtitle">Master CLI tools with interactive exercises</p>

        <Link to="/topics" className="btn btn-hero">
          Start Learning
        </Link>

        {totalXP > 0 && (
          <div className="user-progress">
            <span className="progress-badge">
              Level {level} {title}
            </span>
            <span className="progress-xp">{totalXP} XP</span>
          </div>
        )}
      </section>

      {/* Quick Start Topics */}
      <section className="quick-topics">
        <h2>Popular Topics</h2>
        <div className="topic-cards-grid">
          {popularTopics.map(topic => (
            <Link
              to={`/learn/${topic.id}`}
              key={topic.id}
              className="topic-card-mini"
              style={{ borderColor: topic.color }}
            >
              <span className="topic-icon" style={{ backgroundColor: topic.color }}>
                {topic.icon}
              </span>
              <span className="topic-name">{topic.name}</span>
              <span className="topic-lessons">{topic.lessons} lessons</span>
            </Link>
          ))}
        </div>
        <Link to="/topics" className="see-all-link">
          See All 8 Topics
        </Link>
      </section>

      {/* Simulators */}
      <section className="simulators-section">
        <h3>Interactive Simulators</h3>
        <div className="simulator-links">
          <Link to="/vim-simulator" className="simulator-link">
            <span className="sim-icon">📝</span>
            Vim Simulator
          </Link>
          <Link to="/terraform-simulator" className="simulator-link">
            <span className="sim-icon">🔮</span>
            Terraform Simulator
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
